export default {
    install(Vue, axios) {
        if (!Vue || !axios) {
            console.error('Vue ou Axios não encontrado. Certifique-se de passar as instâncias corretamente.');
            return;
        }

        const getAPIRoot = () => {
            return process.env.VUE_APP_ROOT_API;
        }

        const getAPIHeadersFetch = (_method, _path, _data = {}) => {
            let localStorage = Vue.ls.get(process.env.VUE_APP_LOCAL_STORAGE_NAME);
            const options = {
                method: _method,
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                },
                body: JSON.stringify(_data)
            };
            options.method = _method;

            if (localStorage && JSON.parse(localStorage).token) {
                options.headers.Authorization = `Bearer ${JSON.parse(localStorage).token}`
            }

            return {
                url: `${getAPIRoot()}${_path}`,
                options
            };
        }

        const getAPIHeaders = (_method, _path, _data = {}) => {
            let localStorage = Vue.ls.get(process.env.VUE_APP_LOCAL_STORAGE_NAME);
            let options = {};
            options.method = _method;
            options.url = `${getAPIRoot()}${_path}`;
            options.headers = {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest"
            };

            if (localStorage && JSON.parse(localStorage).token) {
                options.headers.Authorization = `Bearer ${JSON.parse(localStorage).token}`
            }
            if (Object.keys(_data).length > 0) {
                options.data = _data;
            }
            return options;
        }

        const callAPI = async (options) => {
            try {
                const response = await axios(options);
                return response;
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        return error.response.status;
                    }
                    return error.response.data;
                }
                return error.message;
            }
        }

        Vue.prototype.$getAPIHeadersFetch = function (_method, _path, _data = {}) {
            return getAPIHeadersFetch(_method, _path, _data);
        }

        Vue.prototype.$getAPIHeaders = function (_method, _path, _data = {}) {
            return getAPIHeaders(_method, _path, _data);
        }
        Vue.prototype.$AppCallApi = async function (_method, _path, _data = {}) {
            const options = getAPIHeaders(_method, _path, _data);
            const data = await callAPI(options);
            return data;
        }
    }
}